import { UseQueryResult } from "@tanstack/react-query";
import { CurrentUserApiResponse } from "../../types/api.types";
import { queryKeys } from "../queryKeys";
import { useAppQuery, UseAppQueryOptions } from "../useAppQuery";

/**
 * Hook to fetch the current user data
 * Replaces the CurrentUser.get() static method pattern
 *
 * @example
 * const { data, isLoading, error } = useCurrentUser();
 * if (isLoading) return <Spinner />;
 * if (error) return <Error />;
 * return <UserInfo user={data} />;
 */
export function useCurrentUser(
  options?: Omit<UseAppQueryOptions<CurrentUserApiResponse, Error>, "queryKey">
): UseQueryResult<CurrentUserApiResponse, Error> {
  return useAppQuery<CurrentUserApiResponse, Error>("/User", {
    ...options,
    queryKey: queryKeys.users.current()
  });
}
